import LazyLoad from "vanilla-lazyload";

export default class CapeLazy {
    constructor() {
        this.init();
    }

    init() {
        if(window.lazyLoadInstance && typeof window.lazyLoadInstance.destroy === "function") window.lazyLoadInstance.destroy();

        window.lazyLoadInstance = new LazyLoad({
            elements_selector: ".lazy",
        });
    }
};
